import React from 'react';
import logo from '../../assets/umbrella-logo3.png';
import './Header.css';
import Image from 'react-bootstrap/Image';

const Header = () => {

	return (
        <>
            <div className="row">
                <div className="col-md-2 col-sm-2 col-lg-2">
                    <a href="https://portal.umbrellaiot.com" target="_blank">
                        <Image src={logo} className="custom-icon" />
                    </a>
                </div>
                <div className="col-md-8 col-sm-8 col-lg-8 header-text">
                    <b>Umbrella - Report Issue</b>
			    </div>
            </div>
        </>
	);
};
export default Header;
